// @ts-nocheck
import React from 'react';

const ProvinciaPage = () => {
  return (
    <section className="pt-6 pb-10">
      <div className="container md:px-[65px]">
        <div className="flex flex-col md:flex-row">
          <div className="relative md:w-3/5">
            <div class="max-md:hidden mt-3 absolute right-[60px] border-[#A81414]
              w-0 h-0
              border-t-[60px] border-b-[60px] border-r-[30px]
              border-t-transparent border-b-transparent border-l-red-600">
            </div>
            <div class="md:hidden block absolute bottom-0 md:left-0 md:-translate-y-1/2 border-[#A81414]
              w-0 h-0
              border-b-[30px] border-l-[calc(50vw-20px)] border-r-[calc(50vw-20px)]
              md:border-t-[200px] md:border-b-[200px] md:border-l-[100px]
              border-l-transparent border-r-transparent border-t-transparent border-t-red-600">
            </div>
            <div class="max-md:hidden mt-3 absolute right-0 bg-[#A81414] h-[120px] w-[60px]">
            </div>
            <img
              className="md:h-[500px] object-cover object-right w-full max-md:rounded-t-xl md:rounded-xl"
              src="/images/provoncia.jpg"
              alt=""
            />
          </div>
          <div className="relative md:w-2/5  md:h-[500px]">
            <h2 className="md:mt-3 flex py-3  px-4 md:px-6 text-2xl md:text-3xl font-bold text-start uppercase bg-[#A81414] md:h-[120px] items-center text-white md:rounded-tr-xl rounded-br-xl max-md:rounded-bl-xl">
              Провінція Марії Помічниці Християн, УГКЦ
            </h2>
            <div
              // @ts-ignore
              className="flex flex-col py-4 pl-4 text-base md:text-lg md:px-8">
              <ul className="md:pl-6">
                <li
                  // @ts-ignore
                  className="pt-1">
                  <p>
                    ➤
                    Офіс провінційного настоятеля
                  </p>
                </li>
                <li
                  // @ts-ignore
                  className="pt-1">
                  <p>
                    ➤
                    Офіс економа та економічний відділ
                  </p>
                </li>
                <li
                  // @ts-ignore
                  className="pt-1">
                  <p>
                    ➤
                    Офіс провінційної бухгалтерії
                  </p>
                </li>
                <li
                  // @ts-ignore
                  className="pt-1">
                  <p>
                    ➤
                    Офіс провінційного планування та розвитку

                  </p>
                </li>
                <li
                  // @ts-ignore
                  className="pt-1">
                  <p>
                    ➤
                    Офіс VIS

                  </p>
                </li>
                <li
                  // @ts-ignore
                  className="pt-1">
                  <p>
                    ➤
                    Офіс душпастирства молоді

                  </p>
                </li>
                <li
                  // @ts-ignore
                  className="pt-1">
                  <p>
                    ➤
                    Інші стратегічні офіси провінції
                  </p>
                </li>
              </ul>

              <div className="pt-4 md:px-6 text-lg md:text-xl font-bold text-[#A81414]">
                Адреса:
              </div>
              <div className="pb-2 md:px-6 text-lg md:text-xl font-bold text-[#A81414]">
                м. Львів, вул. Личаківська, 175
              </div>
              <div className="md:px-6 text-lg md:text-xl font-bold text-[#A81414]">
                Провінційний настоятель:
              </div>
              <div className="md:px-6 text-lg md:text-xl font-bold text-[#A81414]">
                о. Михайло Чабан, СДБ
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProvinciaPage;
